import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_feedback_with_social_proof~1
			funnel: {
				id: 'ob-female-feedback-with-social-proof',
				locale: ['en'],
			},
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_feedback_with_social_proof~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_feedback_with_social_proof'
					),
			},
		},
	},
]

export default config
